import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_40000108_85616)" }, [
      _createElementVNode("path", {
        d: "M5.91643 10.9973C4.80009 10.9973 3.56295 10.2558 3.1339 9.15617C2.77567 8.20644 2.96312 7.21923 2.9173 6.19453C2.97562 4.92823 2.74652 3.21206 3.16723 2.28733C3.66292 0.991872 5.46656 0.525341 6.44128 1.5917C7.36601 2.64972 7.10358 3.39951 7.15357 4.99488C7.07443 6.08623 7.41599 7.67326 6.73286 8.45637C6.233 9.09785 5.19164 8.87292 4.8709 8.20644C4.60014 7.69409 4.65429 7.13175 4.6418 6.54443C4.7376 5.87379 4.33355 3.51197 5.11666 3.54946C6.0039 3.8702 4.8584 8.09814 5.99557 7.88987C6.57041 7.58579 6.233 5.43641 6.32048 4.37006C6.32048 3.42033 6.33714 2.81634 5.93309 2.34565C5.49572 1.77498 4.60431 1.74165 4.16277 2.32482C3.47964 3.2079 3.83787 4.40755 3.75039 5.61136C3.79205 7.32337 3.31302 9.60604 5.46239 10.0601C6.49126 10.3433 7.76589 9.6227 8.05331 8.6938C8.38654 7.39418 8.11579 5.60303 8.21993 4.29508C8.26575 3.63277 8.60731 3.412 8.83225 3.68276C9.24879 4.45337 8.95721 5.71133 9.04052 6.61524C9.03219 7.99817 9.1155 8.64382 8.58649 9.54772C8.05747 10.4391 7.01611 10.989 5.99141 11.0015H5.91643V10.9973Z",
        fill: "#767676"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_40000108_85616" }, [
        _createElementVNode("rect", {
          width: "10.0335",
          height: "10",
          fill: "white",
          transform: "translate(0.984375 1)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }